<template>
  <div class="c-monitor">
    <!-- filter -->
    <list-filter
      :operator-data="operatorData"
      :game-data="gameData"
      :project-data="projectData"
      @on-change="filterData"
      @on-upload="importExcel"
      @on-down="downExcel"
    />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <list-table
          :loading="loading"
          :data="tableList"
          :height="tableHeight"
          :columns="tableCol"
          @on-detail="queryDetail"
          @on-retry="retryRule"
          @on-edit="editPlan"
          @on-consume="updateConsumeData"
          @on-switch="handleSwitch"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>

    <resulter
      v-model="resultModel"
      type="管控导入"
      down-fail
      :req="req"
      :add-total="added"
      :fail-total="failure"
      :update-total="update"
      @on-close="resultOk"
      @on-down="downFailData"
    />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/personalcontrol_list_column'
import { HOST_API } from '@/api/config'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, deepCopy } from '@/common/js/utils'
import {
  consumeManageList,
  consumeManageRetry,
  importConsumeConfigExcel,
  updateConsumeManageColumn,
  consumeSwitchChange
} from '@/api/manage.model'
import ListFilter from './components/list-filter'
import ListTable from './components/list-table'
import Resulter from '@/components/export/result-dialog'
import { getSysMember, getMiddleGameList, getSysProject } from '@/api/common.model'

export default {
  name: 'personalcontrollist',
  mixins: [mixin],
  components: { ListFilter, ListTable, Resulter },
  data() {
    return {
      tableHeight: 330,
      operatorData: [],
      gameData: [],
      projectData: [],
      req: null,
      resultModel: null,
      added: 0,
      failure: 0,
      update: 0
    }
  },
  watch: {
    $route(to, from) {
      this.getData()
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      consumeManageList(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
            this.tableList.forEach((ret) => {
              ret.consume = [
                {
                  mondayVal: ret.mondayVal,
                  tuesdayVal: ret.tuesdayVal,
                  wednesdayVal: ret.wednesdayVal,
                  thursdayVal: ret.thursdayVal,
                  fridayVal: ret.fridayVal,
                  saturdayVal: ret.saturdayVal,
                  sundayVal: ret.sundayVal,
                  ruleId: ret.ruleId
                }
              ]
              ret.triggerRules = ret.triggerRules.split(';')
              ret.shutDownCondition = ret.shutDownCondition.split(';')
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    importExcel(file) {
      this.$Spin.show()
      importConsumeConfigExcel({ file })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            this.resultModel = true
            this.added = data.successTotal
            this.failure = data.failTotal
            this.update = data.updateTotal
            this.req = data.requestId
          }
        })
        .catch((err) => {
          this.$Spin.hide()
          this.$Message.error(err)
        })
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    },
    downFailData(req) {
      window.open(`${HOST_API}/api/ptom/consumeManage/downloadImportResult?requestId=${req}`, '_blank')
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_operator_amount_control`, '_blank')
    },
    queryDetail(row) {
      const { ruleId } = row
      this.$router.push({ name: 'personalcontroldetail', query: { ruleId } })
    },
    updateConsumeData(params) {
      delete params._X_ROW_KEY
      updateConsumeManageColumn(params)
        .then((data) => {
          if (data) {
            this.getData()
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },
    handleSwitch(params) {
      consumeSwitchChange(params)
        .then((data) => {
          this.getData()
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },
    retryRule(params) {
      const { ruleId } = params
      this.loading = true
      consumeManageRetry({ ruleId })
        .then((data) => {
          this.loading = false
          if (data) this.getData()
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    editPlan(params) {
      const { ruleId } = params
      this.$router.push({ name: 'personalcontroladd', query: { ruleId, t: 'edit' } })
    },
    preloadData() {
      Promise.all([getSysMember(), getMiddleGameList(), getSysProject()]).then((data) => {
        const [operatorData, gameData, projectData] = data
        if (isArray(operatorData)) this.operatorData = deepCopy(operatorData)
        if (isArray(gameData)) this.gameData = deepCopy(gameData)
        if (isArray(projectData)) this.projectData = deepCopy(projectData)
      })
    },
    setLocalPage(size) {
      setLocal('PERSONALCONTROL_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('PERSONALCONTROL_PAGESIZE')) || 20
    this.tableCol = columns
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
